import React from "react";

export default function AdminSettings({
  customPricing,
  updateCustomPrice,
  updatePersonalisationPrice,
  saveCustomPricing,
  savingCustomPricing,
  codEnabled,
  savingCodEnabled,
  saveCodEnabled,
}) {
  return (
    <div className="mt-6 space-y-6">
      <div className="card-pmt p-6 max-w-2xl">
        <div className="overline">GST Settings</div>
        <h3 className="mt-2 font-bold">GST Settings (Development)</h3>
        <p className="mt-2 text-xs text-stone-500">GST is inactive while PrintMyTees is in development. These settings are prepared for activation when the business goes live.</p>
        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div><div className="label-pmt">GST Status</div><select className="input-pmt" defaultValue="not_registered" disabled><option value="not_registered">Not Registered</option><option value="registered">Registered</option></select></div>
          <div><div className="label-pmt">GSTIN</div><input className="input-pmt" placeholder="Enter after GST registration" disabled /></div>
          <div><div className="label-pmt">Business Name</div><input className="input-pmt" value="PrintMyTees" readOnly /></div>
          <div><div className="label-pmt">State</div><input className="input-pmt" value="Tamil Nadu" readOnly /></div>
          <div><div className="label-pmt">Default GST Rate</div><input className="input-pmt" placeholder="Set when GST is activated" disabled /></div>
          <div><div className="label-pmt">Show GST on Invoice</div><select className="input-pmt" defaultValue="off" disabled><option value="off">OFF</option><option value="on">ON</option></select></div>
        </div>
        <div className="mt-4 p-3 border border-amber-200 bg-amber-50 text-xs text-amber-800">GST will not be shown or calculated for customer orders or invoices during development.</div>
      </div>

      {customPricing && (
        <div className="mt-6 card-pmt p-6" data-testid="custom-pricing-settings">
          <div className="overline">Customization Pricing</div>
          <h3 className="mt-2 font-bold" style={{ fontFamily: "Barlow Condensed, sans-serif" }}>Base, Printing & Personalisation Charges</h3>
          <p className="mt-2 text-xs text-stone-500">These prices control the custom apparel calculator and server-validated order price.</p>
          <div className="mt-6 space-y-6">
            {Object.entries(customPricing.pricing || {}).map(([group, config]) => (
              <div key={group} className="border border-[#E6DFD5] p-4">
                <div className="font-semibold uppercase text-sm">{group}</div>
                <div className="mt-4">
                  <div className="label-pmt">Base / Style Prices</div>
                  <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                    {Object.entries(config.styles || {}).map(([name, value]) => (
                      <label key={name} className="text-xs text-stone-700"><span className="block mb-1">{name}</span><div className="flex items-center border border-[#E6DFD5] bg-white"><span className="px-3 text-stone-500">₹</span><input type="number" min="0" step="1" className="input-pmt border-0" value={value} onChange={(e) => updateCustomPrice(group, "styles", name, e.target.value)} /></div></label>
                    ))}
                  </div>
                </div>
                <div className="mt-5">
                  <div className="label-pmt">Printing Charges</div>
                  <div className="mt-2 grid grid-cols-1 sm:grid-cols-3 gap-3">
                    {Object.entries(config.printing || {}).map(([name, value]) => (
                      <label key={name} className="text-xs text-stone-700"><span className="block mb-1">{name}</span><div className="flex items-center border border-[#E6DFD5] bg-white"><span className="px-3 text-stone-500">₹</span><input type="number" min="0" step="1" className="input-pmt border-0" value={value} onChange={(e) => updateCustomPrice(group, "printing", name, e.target.value)} /></div></label>
                    ))}
                  </div>
                </div>
              </div>
            ))}
            <div className="border border-[#E6DFD5] p-4"><div className="font-semibold uppercase text-sm">Personalisation</div><div className="mt-2 grid grid-cols-1 sm:grid-cols-3 gap-3">{Object.entries(customPricing.personalisation || {}).map(([name, value]) => (<label key={name} className="text-xs text-stone-700"><span className="block mb-1">{name === "name" ? "Custom Name" : name === "number" ? "Jersey Number" : "Custom Text"}</span><div className="flex items-center border border-[#E6DFD5] bg-white"><span className="px-3 text-stone-500">₹</span><input type="number" min="0" step="1" className="input-pmt border-0" value={value} onChange={(e) => updatePersonalisationPrice(name, e.target.value)} /></div></label>))}</div></div>
            <div className="flex justify-end"><button type="button" className="btn-primary" onClick={saveCustomPricing} disabled={savingCustomPricing}>{savingCustomPricing ? "Saving…" : "Save Customization Pricing"}</button></div>
          </div>
        </div>
      )}

      <div className="card-pmt p-6 max-w-2xl" data-testid="cod-availability-settings">
        <div className="overline">Checkout Payments</div>
        <h3 className="mt-2 font-bold" style={{ fontFamily: "Barlow Condensed, sans-serif" }}>Cash on Delivery</h3>
        <p className="mt-2 text-sm text-stone-600">Choose whether customers can select Cash on Delivery at checkout. Online payments through Razorpay remain available either way.</p>
        <div className="mt-5 flex items-center justify-between gap-4 border border-[#E6DFD5] p-4">
          <div>
            <div className="font-semibold">{codEnabled ? "COD is enabled" : "COD is disabled"}</div>
            <div className="mt-1 text-xs text-stone-500">{codEnabled ? "Customers can place orders and pay when delivered." : "COD is hidden at checkout and new COD orders are rejected by the server."}</div>
          </div>
          <button
            type="button"
            role="switch"
            aria-checked={codEnabled}
            aria-label="Enable Cash on Delivery"
            data-testid="toggle-cod-availability"
            disabled={savingCodEnabled}
            onClick={() => saveCodEnabled(!codEnabled)}
            className={`relative inline-flex h-7 w-12 shrink-0 items-center rounded-full transition-colors disabled:opacity-50 ${codEnabled ? "bg-green-600" : "bg-stone-300"}`}
          >
            <span className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${codEnabled ? "translate-x-6" : "translate-x-1"}`} />
          </button>
        </div>
        <p className="mt-3 text-xs text-stone-500">Changes save immediately. Existing orders are not changed.</p>
      </div>

      <div className="mt-6 card-pmt p-6 max-w-2xl" data-testid="ekart-shipping-settings">
        <div className="overline">Shipping Integration</div>
        <h3 className="mt-2 font-bold" style={{fontFamily:"Barlow Condensed, sans-serif"}}>Ekart Shipping</h3>
        <p className="mt-2 text-sm text-stone-600">
          Prepare your Ekart account here. API connection will be enabled only after Ekart supplies the API username and password and the backend credentials are configured securely in Render.
        </p>
        <div className="mt-4 flex items-center justify-between gap-3 border border-amber-200 bg-amber-50 p-4">
          <div>
            <div className="font-semibold text-amber-900">Not connected</div>
            <div className="mt-1 text-xs text-amber-800">Shipment booking and tracking API calls are disabled until credentials are available.</div>
          </div>
          <span className="shrink-0 rounded-full border border-amber-300 px-3 py-1 text-xs font-semibold text-amber-800">Setup pending</span>
        </div>
        <div className="mt-5">
          <div className="text-xs font-bold uppercase text-stone-500">Setup checklist</div>
          <ul className="mt-3 space-y-3 text-sm text-stone-700">
            <li className="flex gap-2"><span className="text-green-700">✓</span><span>Ekart account created and pickup details registered in Ekart.</span></li>
            <li className="flex gap-2"><span className="text-amber-700">○</span><span>Receive API username and password from Ekart support.</span></li>
            <li className="flex gap-2"><span className="text-amber-700">○</span><span>Store credentials as private Render environment variables; never in this dashboard or GitHub.</span></li>
            <li className="flex gap-2"><span className="text-amber-700">○</span><span>Verify authentication, shipment booking, label generation, pickup, and tracking before enabling live use.</span></li>
          </ul>
        </div>
        <div className="mt-5 border border-[#E6DFD5] p-4">
          <div className="font-semibold">Connection requirements</div>
          <div className="mt-2 grid grid-cols-1 gap-2 text-sm text-stone-600 sm:grid-cols-2">
            <div><span className="text-stone-500">Account:</span> Existing Ekart account</div>
            <div><span className="text-stone-500">GST:</span> Follow the eligibility and documents confirmed by Ekart</div>
            <div><span className="text-stone-500">API username:</span> Awaiting Ekart</div>
            <div><span className="text-stone-500">API password:</span> Awaiting Ekart</div>
          </div>
        </div>
        <p className="mt-3 text-xs text-stone-500">This panel is a setup tracker only. It does not save credentials, book shipments, or change existing order/shipping behaviour.</p>
      </div>

      <div className="mt-6 card-pmt p-6 max-w-2xl" data-testid="admin-settings">
        <div className="overline">Settings</div>
        <h3 className="mt-2 font-bold" style={{fontFamily:"Barlow Condensed, sans-serif"}}>Business Details</h3>
        <ul className="mt-3 text-sm space-y-2 text-stone-700">
          <li>Brand: PrintMyTees</li><li>Website: printmytees.in</li><li>Email: support@printmytees.in</li><li>WhatsApp: +91 9566853582</li>
        </ul>
        <div className="mt-6 p-4 border border-green-200 bg-green-50"><div className="text-xs font-bold uppercase text-green-700">Payment Gateway</div><div className="mt-1 font-semibold">Razorpay</div><div className="mt-1 text-xs text-green-700">Online payment integration is active.</div></div>
        <p className="mt-6 text-xs text-stone-500">Configure prices, sizes, colours and printing methods per product from the Products tab.</p>
        <p className="mt-4 text-xs text-stone-500">Design prices and available colours are controlled from the Designs tab.</p>
        <p className="mt-4 text-xs text-stone-500">Razorpay secret keys must remain on the backend. Never place payment secret keys in frontend code.</p>
      </div>
    </div>
  );
}
